import React, { useState } from 'react';
import rpi1 from '../Assets/Project5/Picture5.png'
import rpi2 from '../Assets/Project5/Picture6.png'
import rpi3 from '../Assets/Project5/picture8.jpeg'


// Sample recent work projects - Replace placeholder images with your actual imports
const recentProjects = [
    {
        id: 1,
        title: "ATELIER JUKU",
        category: "Mr.Rahul Rewenwar",
        location: "Kothrud, Pune",
        year: "2026",
        image: rpi1,
        description: "A seamless integration of biophilic living spaces with sustainable natural greenery and luxury stone finishes."
    },
    {
        id: 2,
        title: "CASE OTERA",
        category: `Mr.Sahil Patil \n Mrs.Rashika Patil`,
        location: "Baner , Pune",
        year: "2026",
        image: rpi2,
        description: "Minimalist architecture framed by curated indoor tropical greens and bespoke ambient lighting."
    },
    {
        id: 3,
        title: "CASA YUME",
        category: "Mr.Kalpesh Sarode Mrs.Sayali Sarode",
        location: "Koregaon Park, Pune",
        year: "2025",
        image: rpi3,
        description: "An urban office sanctuary wrapped in vertical garden modules and warm timber accents."
    }
];

const RecentWorkShowcase = () => {
    const [hoveredCard, setHoveredCard] = useState(null);

    const theme = {
        background: '#FDFCFB',
        surface: '#FFFFFF',
        accent: '#D4AF37',
        textMain: '#2C302E',
        textMuted: '#7A827E',
        border: 'rgba(44, 48, 46, 0.08)'
    };

    const inlineStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

    @keyframes pulseGlow {
        0% { transform: scale(1) translate(0, 0); opacity: 0.3; }
        50% { transform: scale(1.1) translate(20px, -20px); opacity: 0.5; }
        100% { transform: scale(1) translate(0, 0); opacity: 0.3; }
    }

    @keyframes fadeInUp {
        from { opacity: 0; transform: translateY(40px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .recent-work-container {
        animation: fadeInUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }

    .blur-project-card {
        position: relative;
        border-radius: 20px;
        overflow: hidden;
        background: #FFFFFF;
        border: 1px solid rgba(44, 48, 46, 0.1);
        transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
        box-shadow: 0 10px 30px rgba(44, 48, 46, 0.03);
    }

    .blur-project-card:hover {
        transform: translateY(-8px);
        border-color: #D4AF37;
        box-shadow: 0 24px 50px rgba(212, 175, 55, 0.15);
    }

    /* Blur Effect Layer */
    .blur-overlay-layer {
        position: absolute;
        inset: 0;
        backdrop-filter: blur(14px) saturate(120%);
        -webkit-backdrop-filter: blur(14px) saturate(120%);
        background: rgba(253, 252, 251, 0.45);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 30px;
        text-align: center;
        transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
        z-index: 10;
    }

    .blur-project-card:hover .blur-overlay-layer {
        opacity: 0;
        pointer-events: none;
        backdrop-filter: blur(0px);
        -webkit-backdrop-filter: blur(0px);
    }

    .project-media-img {
        width: 100%;
        height: 480px;
        object-fit: cover;
        transition: transform 0.8s cubic-bezier(0.16, 1, 0.3, 1), filter 0.6s ease;
        filter: blur(4px) brightness(0.9);
    }

    .blur-project-card:hover .project-media-img {
        transform: scale(1.05);
        filter: blur(0px) brightness(1);
    }

    /* Info Drawer revealed on hover */
    .revealed-info-drawer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 32px;
        background: linear-gradient(to top, rgba(44, 48, 46, 0.95) 0%, rgba(44, 48, 46, 0.6) 70%, transparent 100%);
        color: #FFFFFF;
        transform: translateY(100%);
        transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
        z-index: 12;
    }

    .blur-project-card:hover .revealed-info-drawer {
        transform: translateY(0);
    }

    @media (max-width: 900px) {
        .projects-grid-layout {
            grid-template-columns: 1fr !important;
        }
        .project-media-img {
            height: 380px !important;
        }
    }
    `;

    return (
        <div style={{
            background: theme.background,
            minHeight: '100vh',
            color: theme.textMain,
            padding: '90px 40px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            position: 'relative',
            overflow: 'hidden',
            boxSizing: 'border-box'
        }}>
            <style>{inlineStyles}</style>

            {/* Ambient Background Glowing Orbs */}
            <div style={{
                position: 'absolute',
                top: '-10%',
                left: '-5%',
                width: '500px',
                height: '500px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(212, 175, 55, 0.12) 0%, rgba(253, 252, 251, 0) 70%)',
                animation: 'pulseGlow 10s infinite ease-in-out',
                pointerEvents: 'none'
            }} />
            <div style={{
                position: 'absolute',
                bottom: '-10%',
                right: '-5%',
                width: '600px',
                height: '600px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(44, 48, 46, 0.05) 0%, rgba(253, 252, 251, 0) 70%)',
                animation: 'pulseGlow 12s infinite ease-in-out reverse',
                pointerEvents: 'none'
            }} />

            {/* Section Header */}
            <div className="recent-work-container" style={{
                textAlign: 'center',
                maxWidth: '800px',
                margin: '0 auto 70px auto',
                position: 'relative',
                zIndex: 2
            }}>
                <span style={{
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '5px',
                    color: theme.accent,
                    display: 'block',
                    marginBottom: '12px'
                }}>
                    Portfolio Preview
                </span>
                <h1 style={{
                    fontFamily: "'Cinzel', serif",
                    fontSize: 'calc(0.3rem + 1.2vw)',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    letterSpacing: '6px',
                    color: theme.textMain,
                    margin: '0 0 16px 0'
                }}>
                    Our Greens & Recent Work
                </h1>
                {/* <p style={{
                    fontSize: '1rem',
                    color: theme.textMuted,
                    lineHeight: '1.7',
                    margin: 0
                }}>
                    Hover or tap over any project below to reveal the unblurred transformation and architectural craftsmanship.
                </p> */}
                <div style={{
                    width: '60px',
                    height: '1px',
                    background: theme.accent,
                    margin: '24px auto 0 auto'
                }} />
            </div>

            {/* Projects Grid */}
            <div className="recent-work-container projects-grid-layout" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
                gap: '40px',
                maxWidth: '1200px',
                margin: '0 auto',
                position: 'relative',
                zIndex: 2
            }}>
                {recentProjects.map((project) => (
                    <div
                        key={project.id}
                        className="blur-project-card"
                        onMouseEnter={() => setHoveredCard(project.id)}
                        onMouseLeave={() => setHoveredCard(null)}
                    >
                        {/* Background Blurred Image */}
                        <img
                            src={project.image}
                            alt={project.title}
                            className="project-card-media project-media-img"
                        />

                        {/* Interactive Blur Overlay Layer */}
                        <div className="blur-overlay-layer">
                            <span style={{
                                fontSize: '0.75rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '3px',
                                color: theme.accent,
                                marginBottom: '12px',
                                background: 'rgba(212, 175, 55, 0.1)',
                                padding: '6px 14px',
                                borderRadius: '20px',
                                border: `1px solid ${theme.accent}`
                            }}>
                                Recent Work To Come
                            </span>
                            <h3 style={{
                                fontFamily: "'Cinzel', serif",
                                fontSize: '1.6rem',
                                fontWeight: '500',
                                color: theme.textMain,
                                margin: '8px 0',
                                letterSpacing: '2px'
                            }}>
                                {project.title}
                            </h3>
                            <p style={{
                                fontSize: '0.85rem',
                                color: theme.textMuted,
                                margin: '0 0 20px 0',
                                letterSpacing: '1px'
                            }}>
                                📍 {project.location}
                            </p>
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '0.8rem',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                                letterSpacing: '2px',
                                color: theme.textMain
                            }}>
                                <span>Hover To Unblur</span>
                                <span>→</span>
                            </div>
                        </div>

                        {/* Revealed Content Drawer */}
                        <div className="revealed-info-drawer">
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '8px'
                            }}>
                                <span style={{
                                    fontSize: '0.75rem',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '2px',
                                    color: theme.accent
                                }}>
                                    {project.category}
                                </span>
                                {/* <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>
                                    {project.year}
                                </span> */}
                            </div>
                            <h3 style={{
                                fontFamily: "'Cinzel', serif",
                                fontSize: '1.5rem',
                                margin: '0 0 10px 0',
                                fontWeight: '400',
                                letterSpacing: '2px'
                            }}>
                                {project.title}
                            </h3>
                            {/* <p style={{
                                fontSize: '0.88rem',
                                opacity: 0.9,
                                lineHeight: '1.6',
                                margin: 0
                            }}>
                                {project.description}
                            </p> */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentWorkShowcase;